module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="bvcompte phx-label-style"></span>\n<span class="bvcompteurs-compteurs-instantanes phx-bold-input-style"></span>\n<span class="bvcompteurs-valorisation"></span><br>\n<span class="bvcompteurs"></span>';
}
return __p;
};
